import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { Asset, AssetDetailType } from '@/common/asset';
import { t } from '@/i18n';
import { axios } from '@/lib/utils/axios';
import { getResponse, toastApiError } from '../common';
import { API_URLS, queryClient } from '../query.client';

export type GetAssetSuccessResponseType = AssetDetailType;

export async function updateAsset(
	id: string,
	assetPayload: Omit<Asset, 'id'>,
): Promise<GetAssetSuccessResponseType | null> {
	console.log('updateAsset called with id:', id, 'and payload:', assetPayload);
	const response = await axios.patch(`${API_URLS.ASSETS.INDEX}/${id}`, assetPayload);
	return getResponse<GetAssetSuccessResponseType>(response.data);
}
export type UpdateAssetPayloadType = {
	id: string;
	assetPayload: Omit<Asset, 'id'>;
};
export function useUpdateAsset() {
	return mutationOptions({
		mutationFn: ({ assetPayload, id }: UpdateAssetPayloadType) => updateAsset(id, assetPayload),
		onSuccess: async (data) => {
			console.log('Asset updated successfully:', data);
			toast.success(t('assets.toast.updated'));
			await queryClient.invalidateQueries({ queryKey: ['assets'] });
		},
		onError: (error) => toastApiError(error),
	});
}
